import React, { useState } from "react";
import { styled } from "@mui/system";
import {
  Title, Subtitle, CTASection, CTAText, EmailFormWrapper, EmailInput, JoinButton, SectionContainer,
  BoxContainer,
  Card,
  CardText,
  BoxContainerTitle
} from "../assets/styles/ContentStyles"
import emailjs from "@emailjs/browser";
import EmailInputComponent from "./EmailInputComponent";

const HowItWorks = () => {

  const steps = [
    {
      title: "Add Your Devices",
      description:
        "Input the devices in your home or office. We'll identify them and begin monitoring immediately.",
    },
    {
      title: "Get Alerted",
      description:
        "Receive real-time notifications when vulnerabilities are discovered, plus a weekly digest summarizing your security status.",
    },
    {
      title: "Take Action",
      description:
        "Follow our clear guidance to secure your devices - from simple fixes you can do yourself to when you should contact the manufacturer or replace a device.",
    },
  ];

  return (
    <SectionContainer>
      <Title>How it Works</Title>
      <Subtitle>Device Security in Three Simple Steps</Subtitle>

      <BoxContainer>
        {steps.map((step, index) => (
          <Card key={index}>
            <BoxContainerTitle>{step.title}</BoxContainerTitle>
            <CardText>{step.description}</CardText>
          </Card>
        ))}
      </BoxContainer>

      <CTASection>
        <CTAText>
          Get real-time device security monitoring & patching from Hackable Devices.
        </CTAText>

        <EmailInputComponent waitlistType="How it Works - Device Monitoring & Alerts" />
      </CTASection>
    </SectionContainer>
  );
};

export default HowItWorks;
